import { CommonDataSharedService } from 'app/services/commonDataSharedService';
import { CommonRequestResponseService } from './../../../services/common-request-response.service';
import { CommonAuthenticationService } from './../../../services/common-authentication.service';
import { DataService } from './../../../services/data.service';
import { NotificationService } from './../../../services/notification.service';
import { Component, Input, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { takeUntil } from 'rxjs/operators';
import { Subject, Subscription } from 'rxjs';
import { StudentGeographyCardComponent } from './student-geography-card/student-geography-card.component';
import { StudentAccommodationsCardComponent } from './student-accommodations-card/student-accommodations-card.component';
import { StudentSettingsCardComponent } from './student-settings-card/student-settings-card.component';
import { StudentMajorsCardComponent } from './student-majors-card/student-majors-card.component';


@Component({
  selector: 'app-student-profile-page-two',
  templateUrl: './student-profile-page-two.component.html',
  styleUrls: ['./student-profile-page-two.component.scss']
})
export class StudentProfilePageTwoComponent implements OnInit, OnDestroy {

  @ViewChild('geographyCard') geographyCard: StudentGeographyCardComponent;
  @ViewChild('settingCard') settingCard: StudentSettingsCardComponent;
  @ViewChild('accomodationCard') accomodationCard: StudentAccommodationsCardComponent;
  @ViewChild('majorCareerCard') majorCareerCard: StudentMajorsCardComponent;

  @Input() studentUserId: number;
  @Input() studentProfileId: number;
  @Input() isStudenFirstLogIn: boolean;

  options = {
    position: ['top', 'right'],
    timeOut: 3000,
    lastOnBottom: true
  };

  allRegionStates = {
    newEngland: this.dataService.getEntity('New England States').item,
    midAtlantic: this.dataService.getEntity('Mid-Atlantic States').item,
    southern: this.dataService.getEntity('South States').item,
    midWest: this.dataService.getEntity('Midwest States').item,
    southWest: this.dataService.getEntity('Southwest States').item,
    western: this.dataService.getEntity('West States').item
  };

  profileData: any;
  specialConsiderationData: any;
  isSpecialConsidrationAvail = false;
  careersValue: any;
  selectedCareerValue = [];
  selectedMajorList = [];
  majors: any;
  cityList = [];
  majorList = [];
  careersList = [];
  valueCityArray = [];
  valueSpecialConsidrationArray = [];
  allList = [];
  textFlag: any;
  careersAutoArray = [];
  majorAutoArray = [];
  studentProfileLoader = true;
  userRole: any;
  unsureValue = false;
  firstCall = false;
  subs: Subscription[] = [];

  private radix = 10; // conforming to radix parameter use for parseInt() instances. 10 === decimal
  private destroyed$ = new Subject();

  constructor(
    private notificationService: NotificationService,
    private dataService: DataService,
    private _commonAuthService: CommonAuthenticationService,
    private _commonRequestResponseService: CommonRequestResponseService,
    public router: Router,
    private commonDataSharedService: CommonDataSharedService,
    private routes: ActivatedRoute
  ) {
  }

  ngOnInit() {
    this.subs.push(
      this.commonDataSharedService.saveProfile.subscribe(() => {
        if (this.geographyCard.formsTouched || this.settingCard.formsTouched || this.accomodationCard.formsTouched || this.majorCareerCard.formsTouched) {
          const currentRoute = this.routes.snapshot.url[0].path;
          this.commonDataSharedService.saveModal.next(currentRoute);
          this.commonDataSharedService.duplicateContact.next(true);
        };
      }),
      this.commonDataSharedService.goBackFlag
        .pipe(takeUntil(this.destroyed$))
        .subscribe((data: any) => {
          if (data === 'pageTwo') {
            this.firstCall = false;
          }
        })
    )

    window.scrollTo(0, 0);
    const loginData = this._commonAuthService.getLoginData();
    this.textFlag = loginData.isFirstLogOn;
    this.userRole = loginData.role;

    this.getMajorData();
    this.getCitySizeData();
    this.getSupportServiceData();
    this.getCareerData();
    if (this.studentUserId) {
      this.getProfileTwoData();
    }
  }

  saveData() {
    const module = this._commonAuthService.getModule();
      const cityList = this.settingCard.getSettingsData().cityList;
      const stateRegionList = this.geographyCard.getGeographyData().stateList;
      const specialConsiderationData = this.accomodationCard.getSpecialConsidrationData();
      const majorAndCareerData = this.majorCareerCard.getCareerMajorList();

      this.allList = [];
      this.onSelectCity(cityList);
      this.onSpecialConsideration(specialConsiderationData);

      const inputJson = {
        studentUserId: this.studentUserId.toString(),
        regionStateClassIds: stateRegionList,
        citySizeClassIds: this.valueCityArray,
        specialConsiderationClassIds: this.valueSpecialConsidrationArray,
        majorClassIds: majorAndCareerData.majorList,
        careerClassIds: majorAndCareerData.careerList,
        firstCall: !!this.textFlag,
        majorCareerUnsure: false,
      };

      this._commonRequestResponseService.postWithHeader('student/questionnaire2', inputJson)
        .subscribe(
          () => {
            this.notificationService.show('success', 'Profile saved Successfully');
            this.firstCall = false;
          }, () => {
            this.notificationService.show('error', 'Error while saving profile data');
            this.firstCall = true;
          });
 
  }

  ngOnDestroy() {
    this.subs.forEach(sub => sub.unsubscribe());
    const module = this._commonAuthService.getModule();

    this.destroyed$.next(true);
  }

  getSupportServiceData() {
    this.specialConsiderationData = this.dataService.getEntity('Special Considerations').item || [];
    this.isSpecialConsidrationAvail = this.specialConsiderationData.length > 0;

  }

  getCitySizeData() {
    const list = this.dataService.getEntity('City Size').item || [];
    this.cityList = list.map(entry => Object.assign(entry, { checkedValue: false }));
  }

  getMajorData() {
    this.majorList = this.dataService.getEntity('Major').item || [];
    this.majorAutoArray = this.majorList.map(entry => entry.text);
  }

  getCareerData() {
    this.careersList = this.dataService.getEntity('Careers').item || [];
    this.careersAutoArray = this.careersList.map(entry => entry.text);
  }

  onSelectCity(value) {
    this.valueCityArray = [];
    if (value && value.length > 0) {
      for (let i = 0; i < value.length; i++) {
        if (value[i].checkedValue === true) {
          this.valueCityArray.push(value[i].id);
        }

      }
    }
  }

  onSpecialConsideration(value) {
    this.valueSpecialConsidrationArray = [];
    if (value && value.length > 0) {
      for (let i = 0; i < value.length; i++) {
        if (value[i].checkedValue === true) {
          this.valueSpecialConsidrationArray.push(value[i].id);
        }
      }
    }
  }

  getProfileTwoData() {
    this.studentProfileLoader = true;

    const selectedType = {
      profileId: this.studentProfileId
    };

    this.allList = [];

    this._commonRequestResponseService.postWithHeader('student/getprofile1/', selectedType, ['profileId'])
      .pipe(takeUntil(this.destroyed$))
      .subscribe(
        (getProfileData: any) => {
          this.studentProfileLoader = false;
          if (getProfileData && getProfileData.data) {
            this.profileData = getProfileData.data;

            if (getProfileData.data.citySizeClassIds && getProfileData.data.citySizeClassIds.length > 0) {
              for (let j = 0; j < getProfileData.data.citySizeClassIds.length; j++) {
                this.valueCityArray.push(parseInt(getProfileData.data.citySizeClassIds[j], this.radix));
              }
            }

            if (this.cityList && this.cityList.length > 0 && getProfileData.data.citySizeClassIds && getProfileData.data.citySizeClassIds.length > 0) {
              for (let j = 0; j < this.cityList.length; j++) {
                if (getProfileData.data.citySizeClassIds.indexOf(this.cityList[j].id + '') > -1) {
                  this.cityList[j]['checkedValue'] = true;
                }
              }
            }

            if (getProfileData.data.specialConsiderationClassIds && getProfileData.data.specialConsiderationClassIds.length > 0) {
              for (let k = 0; k < getProfileData.data.specialConsiderationClassIds.length; k++) {
                this.valueSpecialConsidrationArray.push(parseInt(getProfileData.data.specialConsiderationClassIds[k], this.radix));
              }
            }

            if (this.specialConsiderationData && this.specialConsiderationData.length > 0) {
              for (let j = 0; j < this.specialConsiderationData.length; j++) {
                if (getProfileData.data.specialConsiderationClassIds && getProfileData.data.specialConsiderationClassIds.length > 0) {
                  if (getProfileData.data.specialConsiderationClassIds.indexOf(this.specialConsiderationData[j].id + '') > -1) {
                    this.specialConsiderationData[j]['checkedValue'] = true;
                  }
                }
              }
            }

            this.careersValue = null;
            this.selectedCareerValue = [];
            if (this.careersList && this.careersList.length > 0 && getProfileData.data.careerClassIds && getProfileData.data.careerClassIds.length > 0) {
              for (let j = 0; j < this.careersList.length; j++) {
                if (getProfileData.data.careerClassIds.indexOf(this.careersList[j].id + '') > -1) {
                  this.selectedCareerValue.push(this.careersList[j].id);
                  this.careersList[j]['checked'] = true;
                }
              }
            }

            this.majors = null;
            this.selectedMajorList = [];
            if (this.majorList && this.majorList.length > 0 && getProfileData.data.majorClassIds && getProfileData.data.majorClassIds.length > 0) {
              for (let j = 0; j < this.majorList.length; j++) {
                if (getProfileData.data.majorClassIds.indexOf(this.majorList[j].id + '') > -1) {
                  this.selectedMajorList.push(this.majorList[j].id);
                  this.majorList[j]['checked'] = true;
                }
              }
            }

            this.unsureValue = getProfileData.data.majorCareerUnsure;
          }

          this.firstCall = true;
        },
        () => {
          this.studentProfileLoader = false;
          this.notificationService.show('error', 'Error while fetching west states');
        },
        () => {
          this.studentProfileLoader = false;
        });
  }
}
